const C = {
  name: "Lock2",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M13 15C13 15.5523 12.5523 16 12 16C11.4477 16 11 15.5523 11 15C11 14.4477 11.4477 14 12 14C12.5523 14 13 14.4477 13 15Z" fill="currentColor"/>
<path d="M12 1C9.23858 1 7 3.23858 7 6V8.75463C5.17108 10.2207 4 12.4736 4 15C4 19.4183 7.58172 23 12 23C16.4183 23 20 19.4183 20 15C20 12.4736 18.8289 10.2207 17 8.75463V6C17 3.23858 14.7614 1 12 1ZM15 7.58152C14.0736 7.20651 13.0609 7 12 7C10.9391 7 9.92643 7.20651 9 7.58152V6C9 4.34315 10.3431 3 12 3C13.6569 3 15 4.34315 15 6V7.58152ZM12 9C15.3137 9 18 11.6863 18 15C18 18.3137 15.3137 21 12 21C8.68629 21 6 18.3137 6 15C6 11.6863 8.68629 9 12 9Z" fill="currentColor"/>
</svg>
  `
};
export {
  C as Lock2
};
